import React from "react";
import { Outlet } from "react-router-dom";

export default function RecruitmentTest() {
  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full bg-lightPrimary dark:!bg-navy-900">
      {/* Main Content - Full Width without Navbar/Sidebar */}
      <main className="mx-auto h-full w-full">
        <div className="h-full min-h-screen">
          <Outlet />
        </div>
      </main>
    </div>
  );
}